module.exports = __webpack_public_path__ + "static/media/logo_avacon.ecc73fd6.png";